import { PropsWithChildren, useEffect } from "react";

export const metadata = {
  title: "Dulain's Portfolio",
  description: "Personal portfolio website of Dulain Gunawardhana — Computer Science, Software Engineering and Toastmasters.",
  icons: {
    icon: "/logo.svg",
    shortcut: "/logo.svg",
    apple: "/logo.svg",
  },
};

export function Layout({ children }: PropsWithChildren) {
  useEffect(() => {
    // Set document title
    if (metadata.title) {
      document.title = metadata.title;
    }

    // Ensure description meta exists
    const name = "description";
    let meta = document.querySelector(`meta[name="${name}"]`);
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", name);
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", metadata.description);
  }, []);

  return <>{children}</>;
}
